import { SHSignStatus, SIGN_STATUS_LABELS } from "../../../../../models/server/signatureHandler";
import { BadgeVariant } from "./orderStatusUtils";

export const contractStatusVariant = (status: SHSignStatus | null): BadgeVariant => {
    switch (status) {
        case "signed":
        case "closed":
            return "success";
        case "canceled":
        case "rejected":
        case "document_error":
        case "ssn_validation_failed":
            return "error";
        case null:
            return "neutral";
        default:
            return "warning";
    }
};

export const contractStatusText = (status: SHSignStatus | null): string =>
    status ? SIGN_STATUS_LABELS[status] : "Ikke signert";
